import { CREATE_EVENT, UPDATE_EVENT, DELETE_EVENT, SET_WEEKENDS_ENABLED } from "@/store/mutation-types";
import { addDays } from 'date-fns'
import { getEventIndexById } from '../utils'


const state = {
    events: [
        { id: 10, title: 'All day event', date: new Date(), allDay: true },
        { id: 20, title: 'Timed event', start: addDays(new Date(), 1) },
        { id: 30, title: 'Timed event', start: addDays(new Date(), 2) }
    ],
    weekendsVisible: true

}

const mutations = {
    [CREATE_EVENT](state, event) {
        return state.events.push(event)
    },
    [UPDATE_EVENT](state, updatedEvent) {
        const index = getEventIndexById(state, updatedEvent.id)

        if (index === -1) {
            return console.warn(`Unable to update event (id ${updatedEvent.id})`)
        }

        return state.events.splice(index, 1, {
            ...state.events[index],
            title: updatedEvent.title,
            start: updatedEvent.start,
            end: updatedEvent.end,
            date: updatedEvent.date
        })
    },
    [DELETE_EVENT](state, eventId) {
        const index = getEventIndexById(state, eventId)

        if (index === -1) {
            return console.warn(`Unable to delete event (id ${eventId})`)
        }

        return state.events.splice(index, 1)
    },
    [SET_WEEKENDS_ENABLED](state, enabled) {
        state.weekendsVisible = enabled
    },
}

const actions = {

    createEvent({ commit }, event) {
        return commit(CREATE_EVENT, event)
    },
    updateEvent({ commit }, updatedEvent) {
        return commit(UPDATE_EVENT, updatedEvent)
    },
    deleteEvent({ commit }, eventId) {
        return commit(DELETE_EVENT, eventId)
    },
    setweekendsVisible({ commit }, enabled) {
        return commit(SET_WEEKENDS_ENABLED, enabled)
    }

}

export default {
    state,
    mutations,
    actions
}